import { PMSNames } from "views/settings-integration/integrations/pms/constants";

type IntegrationLike = {
  name?: string | null;
  integration?: string | null;
};

/**
 * Returns "<name> - <humanized PMS>". Falls back to the humanized PMS
 * alone when name is missing, or null when neither is present.
 */
export const formatIntegrationLabel = (
  source?: IntegrationLike | null
): string | null => {
  if (!source) return null;
  const { name, integration } = source;
  const pmsLabel = integration
    ? ((PMSNames as Record<string, string | undefined>)[
        integration.toLowerCase()
      ] ?? integration)
    : null;
  if (name && pmsLabel) return `${name} - ${pmsLabel}`;
  return name ?? pmsLabel ?? null;
};
